/**
 * f12.1 (Q-f12.1-4): earlier cycles' comments for one review row, read-only,
 * newest first. This cycle's comment is edited in the dialog above it.
 */

import type { ReviewCommentItem } from '@/api/client';

function when(value: string | null): string {
  if (!value) return '';
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? '' : date.toLocaleDateString(undefined, { dateStyle: 'medium' });
}

export function CommentThread({ items, loading }: { items: readonly ReviewCommentItem[]; loading: boolean }) {
  if (loading) return <p className="hint">Loading earlier comments…</p>;
  if (!items.length) return <p className="hint">No comments from earlier cycles.</p>;
  return (
    <ol className="rv-thread" aria-label="Earlier comments">
      {items.map((item) => (
        <li key={item.cycle_id} className="rv-thread-item">
          <div className="rv-thread-head">
            <b>{item.label}</b>
            <span className="mono">{item.cycle_code}</span>
            {item.updated_by && <span className="hint">{item.updated_by}</span>}
            {item.updated_at && <span className="hint">{when(item.updated_at)}</span>}
          </div>
          <p className="rv-thread-body">{item.comment}</p>
        </li>
      ))}
    </ol>
  );
}
